import React, { PropsWithChildren, createContext, useState } from "react";
import PermissionManager from "../Common/PermissionsManager";
import AuthManager from "../Common/AuthManager";
import PermissionsManager from "../Common/PermissionsManager";
import { toast } from "react-toastify";
import readXlsxFile from "read-excel-file";
import { TAttribute } from "types/Pages/ProductDelta";
import * as types from 'types/Context/AppContext';
import ServiceWrapper from "Services/ServiceWrapper";
import { PREPARE_FILE_MESSAGE, TECHNICAL_ERROR_MESSAGE } from "Components/GMS/Rules/Components/RuleConstants";
import { uploadStatus } from "Components/GMS/Pdw/APIServices/Services";
import { IRefreshHierarchy } from "types/Context/IRefreshHierarchy";
export const AppContext = createContext<types.TAppContext>({} as types.TAppContext);


// This context provider is passed to any component requiring the context
export const AppContextProvider = ({ children }: PropsWithChildren) => {
const pm = new PermissionsManager();

// ================================= Analytics ====================================
const [selectedItem, setSelectedItem] = useState({
  label: "Select Date",
  value: ""
});
// ================================= Analytics ===================================

  const [selectedIndustry, setSelectedIndustry] = useState<types.TIndustry>(null);
  const [productImagesGlobal, setProductImagesGlobal] = useState<types.TproductImagesGlobal>([]);
  const [builderImagesGlobal, setBuilderImagesGlobal] = useState<types.TproductImagesGlobal>([]);
  const [longDescriptionGlobal, setLongDescriptionGlobal] = useState<types.TlongDescriptionGlobal>(null);
  const [selectedParty, setSelectedParty] = useState<types.TParty>(null);
  const [loggedinUser, setLoggedinUser] = useState<types.TloggedinUser>(null);
  const [productDeleted, setProductDeleted] = useState<types.TproductDeleted>(false);
  const [searchedAttributeList, setSearchedAttributeList] = useState<TAttribute[]|null>(null);
  const [categoryTypeList, setCategoryTypeList] = React.useState<types.Tcategory[]>([]);
  const [attributeList, setAttributeList] = useState<TAttribute[]|null>(null);
  const [categoryList, setCategoryList] = React.useState<types.Tcategory[]>([]);
  const [checkedAttValues, setChechedAttValues] = useState<types.TcheckedAttValues>([]);
  const [unCheckvalue, setUncheckValue] = useState<types.TunCheckvalue>(false);
  const [recordPerPage, setRecordPerPage] = useState<types.TrecordPerPage>(100);
  const [productsList, setProductsList] = useState<types.TProductList>(null);
  const [productAttrList, setProductAttrList] = useState<types.TproductAttrList>(null);
  const [productsListCopy, setProductsListCopy] = useState<types.TProductList>(null);
  const [categorySaveId, setCategorySaveId] = React.useState<types.TcategorySaveId>("");
  const [rowsCount, setRowsCount] = useState<types.TrowsCount>(0);
  const [catType, setCatType] = useState<types.TcatType>("");
  const [productCount, setProductCount] = useState<number>(0);
  const [builderCount, setBuilderCount] = useState<number>(0);
  const [showSummaryProductModal, setShowSummaryProductModal] = useState(false);
  const [showUpatedCategoryModal, setShowUpdateCategoryModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [categoryTypeAndCategories, setCategoryTypeAndCategories] = useState(
    []
  );
  const [downloadState, setDownloadState] = useState<types.TDownloadState>({ downloadFlag: false, message: '',});
  const [downloadUrl, setDownloadUrl] = useState<string>("");
  const [userName, setUserName] = useState<string>('');
  const [editingItem, setEditingItem] = React.useState(null);
  const [channelKey, setChannelKey] = React.useState<string>("")
  // we can keep this temp for demo purpose
  const platformInfo = new Map();
  platformInfo.set("JLt4MAZGMnAhA7oNL1gD", "BXPnED3QJaqmGiGAcOYBlSrni68PxGUI");
  platformInfo.set("LeIu4F3vUjgsEtkr1vg5", "0@C$Kj54J8e8nIpma8lFt*1AIS%2zV3y");
  platformInfo.set(
    "iuX5FUzHpou813o5B30m",
    "l9LcJuS8h6AOXsWErPX5SfmcETfmzJQXEjIDd"
  );
  platformInfo.set("j2m5lq9uNbV4ETc0skb0", "cTi9gLaSomyYvXhuMHQx8ilb3EhjTzx");

  // Once subscriptions is defined in SAMS we can remove this
  const applications = new Map();

  applications.set("Midway", ["Compatio","Commend (ARS)"]);
  applications.set("MRFC", ["Compatio","Bundler", "SmartBuilder", "XRS", "XCS", "Guide"]);
  applications.set("RedsFlyFishing", ["Compatio", "Bundler", "SmartBuilder", "XRS", "XCS"]);
  applications.set("Galco", ["Compatio", "Commend (ARS)", "XRS", "Guide"]);
  applications.set("Midway-demo", ["Compatio", "Commend (ARS)", "Bundler", "SmartBuilder", "XRS", "XCS"]);
  applications.set("Test-Midway", ["Compatio", "Commend (ARS)", "Bundler", "SmartBuilder", "XRS", "XCS"]);
  applications.set("Test-Galco", ["Compatio", "Commend (ARS)", "Guide", "XRS"]);
  applications.set("IronBow", ["Compatio", "Bundler", "SmartBuilder", "XRS", "XCS"]);
  applications.set("Compatio", ["Compatio", "Commend (ARS)", "Bundler", "SmartBuilder", "XRS", "XCS", "Guide"]);
  applications.set("Wolf", ["Compatio", "Guide", "Commend (ARS)", "XRS"]);
  applications.set("WolfQA", ["Compatio", "Guide", "Commend (ARS)", "XRS"]);
  applications.set("SunshineBikeShop", ["Compatio", "Bundler", "SmartBuilder", "XRS", "XCS"]);
  applications.set("GrabAGun", ["Compatio", "Commend (ARS)", "XRS", "Guide"]);

  let reset = () => {
    setSearchedAttributeList(null);
    setCategoryTypeList([]);
    setAttributeList(null);
    setCategoryList([]);
    setChechedAttValues([]);
    setUncheckValue(false);
    setRecordPerPage(100);
    setProductsList(null);
    setProductAttrList(null);
    setProductsListCopy(null);
    setShowSummaryProductModal(false);
    setShowUpdateCategoryModal(false);
    setSelectedProducts([]);
  };

  let resetFilterList = () => {
    setChechedAttValues([]);
    setUncheckValue(false);
    setSearchedAttributeList(null);
    setCategoryTypeList([]);
    setAttributeList(null);
    setCategoryList([]);
    setChechedAttValues([]);
    setProductsList(null);
    setProductAttrList(null);
    setProductsListCopy(null);
    setShowSummaryProductModal(false);
    setShowUpdateCategoryModal(false);
    setSelectedProducts([]);
  };

  const update_industry = (newIndustry: types.TIndustry) => {
    setSelectedIndustry(newIndustry);
    AuthManager.setWorkspaceStatus(
      newIndustry !== null && newIndustry !== undefined
    );
  };

  const update_party = (newParty: types.TParty) => {
    setSelectedParty(newParty);
  };

  const get_selected_industry = () => {
    return selectedIndustry;
  };

  const get_selected_party = () => {
    return selectedParty;
  };

  const check_roles = () => {
    let permissionObj = new PermissionManager();
    const response = permissionObj.get_roles();
    switch (response) {
      case "catalogManager":
        return { roles: "Catalog Manager", menu: "Catalog" };
      default:
        return "Guest";
    }
  };

  const [refreshHierarchy, setRefreshHierarchy] = useState<IRefreshHierarchy>({
    refreshParties: () => {},
    refreshDomains: () => {},
    refreshChannels: () => {},
    refreshEnvironments: () => {},
    refreshAll: () => {}
  });

  const checkSelectedFile = async (file: File, type: string) => {
    let count = 0;
    if (
      type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      await readXlsxFile(file, { sheet: 1 })
        .then(async (rows) => {
          if (rows.length > 0) {
            await readXlsxFile(file, { sheet: "Data" })
              .then((sheet2rows) => {
                let sheet2Count = sheet2rows.length - 1;
                if (sheet2Count > 0) {
                  count = sheet2Count;
                  setRowsCount(sheet2Count);
                } else {
                  toast.error("Invalid File!");
                }
              })
              .catch((er) => {
                if (
                  er
                    .toString()
                    .includes('Sheet "Data" not found in the *.xlsx file')
                ) {
                  toast.error("Invalid .xlsx file format!");
                } else {
                  count++;
                  setRowsCount(1);
                }
              });
          } else {
            toast.error("File is empty!");
          }
        })
        .catch((er) => {
          toast.error("This .xlsx file is corrupted!");
        });
    } else {
      toast.error("Only .xlsx files are allowed to upload!");
    }
    return count;
  };

  const downloadCBMFile = async (productDownloadEndPoint: string, payload: any) => {
    try {
      setDownloadUrl("");
      const response = await ServiceWrapper.doPost( productDownloadEndPoint, payload, null, AuthManager.getGmsToken());
      if (!response.errorfound) {
        if (response.data.done) {
          //toast.success(response?.data?.message);
          setDownloadState({ downloadFlag: true, message: response?.data?.message ?? '' });
          checkUploadStatus(response?.data?.job_id);
        }
      } else {
        setDownloadState({ downloadFlag: false, message: '' });
        toast.error(response?.data?.message ?? "Download failed");
      }
    } catch (error) {
      console.error("downloadCBMFile ~ error:", error)
    }
  }

  const checkUploadStatus = async (jobId: string) => {
    try {
      if (jobId) {
        const response = await uploadStatus(jobId);
        if (response.errorfound) {
          toast.error(TECHNICAL_ERROR_MESSAGE);
          setDownloadState({ downloadFlag: false, message: '' });
          return;
        }

        if (response?.error) {
          setDownloadState({ downloadFlag: false, message: '' });
          toast.error(response?.status ? response?.status : response?.data?.message);
          return;
        }

        if (response?.processing) {
          setDownloadState({ downloadFlag: true, message: response?.data?.status ?? PREPARE_FILE_MESSAGE });
          setTimeout(() => checkUploadStatus(jobId), 2000);
        }

        if (response?.done) {
          setDownloadState({ downloadFlag: false, message: '' });
          setDownloadUrl(response?.data);
          toast.success(response?.message);
          setTimeout(() => {
            setDownloadUrl('');
          }, 5000);
        }
      } else {
        toast.error("Job Id not found");
      }  
    } catch (error) {
      setDownloadState({ downloadFlag: false, message: '' });
      console.error("checkUploadStatus ~ error:", error);
    }
  }

  return (
    <AppContext.Provider
      value={{
        selectedIndustry,
        selectedParty,
        loggedinUser,
        setSelectedIndustry,
        setSelectedParty,
        setLoggedinUser,
        get_selected_industry,
        get_selected_party,
        update_industry,
        update_party,
        check_roles,
        pm,
        productImagesGlobal,
        setProductImagesGlobal,
        builderImagesGlobal,
        setBuilderImagesGlobal,
        longDescriptionGlobal,
        setLongDescriptionGlobal,
        productDeleted,
        setProductDeleted,
        searchedAttributeList,
        setSearchedAttributeList,
        categoryTypeList,
        setCategoryTypeList,
        attributeList,
        setAttributeList,
        categoryList,
        setCategoryList,
        checkedAttValues,
        setChechedAttValues,
        unCheckvalue,
        setUncheckValue,
        recordPerPage,
        setRecordPerPage,
        reset,
        resetFilterList,
        productsList,
        setProductsList,
        productAttrList,
        setProductAttrList,
        productsListCopy,
        setProductsListCopy,
        categorySaveId,
        setCategorySaveId,
        platformInfo,
        applications,
        checkSelectedFile,
        rowsCount,
        setRowsCount,
        catType,
        setCatType,
        builderCount,
        setBuilderCount,
        productCount,
        setProductCount,
        showSummaryProductModal,
        setShowSummaryProductModal,
        selectedProducts,
        setSelectedProducts,
        showUpatedCategoryModal,
        setShowUpdateCategoryModal,
        categoryTypeAndCategories,
        setCategoryTypeAndCategories,
        editingItem,
        setEditingItem,
        selectedItem,
        setSelectedItem,
        channelKey,
        setChannelKey,
        userName,
        setUserName,
        downloadState,
        setDownloadState,
        downloadCBMFile,
        downloadUrl,
        setDownloadUrl,
        refreshHierarchy,
        setRefreshHierarchy
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
